import { FileModel, RequestedFile } from 'api';

export type FileToUpload = {
  tmpId: string;
  name: string;
  file: File;
};

export type RequestedFileFulfillmentStatus =
  | 'pending'
  | 'uploaded'
  | 'not_applicable'
  | 'not_available';

export interface RequestedFileExtended extends Omit<RequestedFile, 'files'> {
  id?: number;
  tmpId: string;
  file: File;
  files?: Array<FileModel>;
  fileToUpload?: FileToUpload;
  name: string;
  fulfillment_status?: RequestedFileFulfillmentStatus;
  fulfillment_note?: string | null;
  is_fulfilled?: boolean;
}

export const isRequestedFileFulfilled = (
  file: Pick<RequestedFileExtended, 'is_uploaded' | 'is_fulfilled' | 'fulfillment_status' | 'files'>
): boolean => {
  const isFulfilled = file.is_fulfilled;
  const isNAStatus = file.fulfillment_status === 'not_applicable' || file.fulfillment_status === 'not_available';
  const isUploaded = file.is_uploaded;

  const fileIsComplete = isFulfilled || isNAStatus || isUploaded;

  if (fileIsComplete) {
    return true;
  }

  const hasFiles = Boolean(file.files && file.files.length > 0);

  return hasFiles;
};
